import restful from 'backend/RESTful';

export default {
    ubt: {
        config: restful.ubt.config
    }
};
